<template>
    <button
        class="flex justify-center items-center px-3 rounded-r border-gray-300 border-opacity-0 text-gray-500 hover:bg-blue-500 hover:text-white hover:border-opacity-0 focus:bg-blue-500 focus:text-white group-hover:border-opacity-100 group-focus-within:border-opacity-100 transition duration-150"
        :class="{ disabled: disabled }"
        :disabled="disabled"
        :tabindex="tabindex"
        @click="$emit('click')"
    >
        <icon :class="iconClassName" :name="iconName" />
    </button>
</template>

<script>
    export default {
        emits: ['click'],

        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            iconClassName: {
                type: [String, Array, Object],
                default: '',
            },
            iconName: {
                type: String,
                required: true,
            },
            tabindex: {
                type: [String, Number],
                default: -1,
            },
        },
    };
</script>
